/* ==========================================================================
   VOCAL CHEF — collection browse. Progressive enhancement only: every form
   here submits as a plain GET with JS off, so filtering never depends on JS.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var $  = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };

  /* auto-submit facet + sort forms */
  doc.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-vc-auto-submit]');
    if (!form) return;
    form.submit();
  });

  /* price inputs: submit on Enter / blur rather than on every keystroke */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var f = e.target.closest('.fprice');
    if (!f) return;
    e.preventDefault();
    var form = e.target.closest('form');
    if (form) form.submit();
  });

  /* bottom sheets */
  var lastTrigger = null;
  function sheet(el, open) {
    if (!el) return;
    var scrim = $('[data-vc-sheet-scrim]');
    el.classList.toggle('on', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) scrim.classList.toggle('on', open);
    doc.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      lastTrigger = doc.activeElement;
      var f = el.querySelector('button, input, select, a');
      if (f) setTimeout(function () { f.focus(); }, 60);
    } else if (lastTrigger && lastTrigger.focus) {
      lastTrigger.focus();
    }
  }
  function closeAll() {
    $$('.fsheet').forEach(function (el) { el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); });
    var scrim = $('[data-vc-sheet-scrim]');
    if (scrim) scrim.classList.remove('on');
    doc.documentElement.style.overflow = '';
  }

  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-vc-filters-open]')) { e.preventDefault(); sheet($('[data-vc-filters-sheet]'), true); return; }
    if (e.target.closest('[data-vc-sort-open]'))    { e.preventDefault(); sheet($('[data-vc-sort-sheet]'), true); return; }
    if (e.target.closest('[data-vc-sheet-close]') || e.target.closest('[data-vc-sheet-scrim]')) { e.preventDefault(); closeAll(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $('.fsheet.on')) closeAll();
  });
})();
